var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramCalc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001246",
    d: "M10.399 0c.332 0 .601.25.601.558 0 .28-.222.511-.512.551l-.09.006H7.76L5.746 7.617c-.16.448-.796.51-1.065.142l-.05-.08-1.805-4.432H.6c-.302 0-.552-.206-.594-.475L0 2.691c0-.28.222-.512.512-.551l.09-.007h2.605c.203 0 .39.096.501.25l.042.07 1.328 3.494L6.756.381c.072-.199.257-.341.475-.374L7.327 0h3.072z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramCalc);
export default __webpack_public_path__ + "static/media/program-calc.6e0037dcd64c720322081627be1cb5d2.svg";
export { ForwardRef as ReactComponent };